import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../redux/store';

export interface themeState {
  value: 'dark' | 'light';
}

const initialState: themeState = {
  value: localStorage.getItem('theme') === 'light' ? 'light' : 'dark',
};
export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setTheme: (state, action) => {
      state.value = action.payload
      localStorage.setItem('theme', action.payload)
    },
  }
});

export const selectTheme =(state: RootState) => state.theme.value;

export const { setTheme } = themeSlice.actions;
export default themeSlice.reducer;
